module.exports = __webpack_public_path__ + "img/hr-sand-decal-10.a52db798.png";